import { NotFoundError } from '@magicdoorinc/errors';
import { companyGateway } from '~/gateways/companyInfoGateway';
import type { HostInfo } from '~/use-cases/types/HostInfo';
import { InitializePaymentModeUseCase } from '../initializePaymentModeUseCase';
import { MagicUseCase } from '../magicUseCase';

export class LoadCompanyInfoUseCase extends MagicUseCase<HostInfo> {
  protected async runLogic(host: HostInfo) {
    const user = this.getState().user;
    if (user.domain === host.hostname && (user.companyInfo || user.isCompanyNotFound)) {
      return;
    }
    this.getState().user.domain = host.hostname;
    try {
      const companyInfo = await companyGateway.getCompanyInfo(host.hostname);
      this.getState().user.companyInfo = companyInfo;
      this.getState().user.isCompanyNotFound = false;
    } catch (error) {
      if (!(error instanceof NotFoundError)) {
        throw error;
      }
      this.getState().user.companyInfo = undefined;
      this.getState().user.isCompanyNotFound = true;
    }
    await new InitializePaymentModeUseCase().execute();
  }
}
